export const ROLES = [
	{ value: 'account_manager', label: 'Account Manager' },
	{ value: 'art_director', label: 'Art Director' },
	{ value: 'client', label: 'Client' },
	{ value: 'creative_director', label: 'Creative Director' },
	{ value: 'creative_ops_lead', label: 'Creative Ops Lead' },
	{ value: 'designer', label: 'Designer' },
	{ value: 'digital_tech', label: 'Digital Tech' },
	{ value: 'executive_team', label: 'Executive Team' },
	{ value: 'legal_compliance', label: 'Legal/Compliance' },
	{ value: 'lead_retoucher', label: 'Lead Retoucher' },
	{ value: 'marketing_team', label: 'Marketing Team' },
	{ value: 'merchandise', label: 'Merchandise' },
	{ value: 'photographer', label: 'Photographer' },
	{ value: 'post_production_manager', label: 'Post-production Manager' },
	{ value: 'producer', label: 'Producer' },
	{ value: 'product_manager', label: 'Product Manager' },
	{ value: 'retoucher', label: 'Retoucher' },
	{ value: 'studio_manager', label: 'Studio Manager' },
	{ value: 'stylist', label: 'Stylist' }
];

export const INTENDED_USAGES = [
	{ value: 'deliver_revisions', label: 'Deliver revisions and finals' },
	{ value: 'give_feedback', label: 'Give feedback and/or approve' },
	{ value: 'manage_lifecycle', label: 'Manage project lifecycle' }
];

export const REFERRAL_SOURCES = [
	{ value: 'internet_search', label: 'Internet Search' },
	{ value: 'word_of_mouth', label: 'Word of mouth' },
	{ value: 'linkedin', label: 'Linkedin' },
	{ value: 'instagram', label: 'Instagram' },
	{ value: 'blog_post', label: 'Blog Post' },
	{ value: 'podcast', label: 'Podcast' },
	{ value: 'other', label: 'Other' }
];

export type OnboardingAnswers = {
	role: string,
	intendedUsage: string,
	referralSource: string
}
